import { HeaderData } from "../../../../../hooks/useApiCalls";

function Content() {
  
  const header_items = HeaderData();
  const button1Data = header_items.button1 ? JSON.parse(header_items.button1) : 0;
  const button2Data = header_items.button2 ? JSON.parse(header_items.button2) : 0;
   
     return ( 
        <>
        <h1>{header_items.title}</h1>
              <p>{header_items.detail}</p>
              <div className="hero-buttons">
                <a href={button1Data.link} className="btn btn-primary"> {button1Data.text} <span>→</span></a>
                <a href={button2Data.link} className="btn btn-secondary">{button2Data.text} <span>→</span></a>
              </div>
      </> 
  ); 

}

export default Content;